import React, { FC } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  onAddDriver: () => void;
}

export const Header: FC<HeaderProps> = ({ onAddDriver }) => {
  const { logout } = useAuth();

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <h1 className="text-3xl font-bold text-gray-900">Driver Tracking Admin</h1>
          <div className="flex items-center space-x-4">
            <button
              onClick={onAddDriver}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Add Driver
            </button>
            <button
              onClick={logout}
              className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};